module.exports = __webpack_public_path__ + "static/media/load.ddf20667.gif";